module.exports = {"131123100":"武强镇","131123101":"街关镇","131123102":"周窝镇","131123103":"东孙庄镇","131123200":"豆村乡","131123201":"北代乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131123.json
// module id = 247
// module chunks = 0